import { EXACT_UUID_PATTERN } from '../consts/exact-uuid-pattern.const';

/**
 * Returns the directory when the whole string is one UUID.
 *
 * File storage keeps each file in a directory named by that UUID. A prefix,
 * a suffix, or another path segment is not a directory name (`../<uuid>`,
 * `<uuid>/file`). The match is {@link EXACT_UUID_PATTERN}: hyphenated, either
 * hex case, version digit 1–8, variant digit 8, 9, a, or b.
 *
 * @param directory - Storage directory the caller named
 * @returns The same directory when it is one UUID
 * @throws When the directory is not one UUID
 *
 * @example
 * sanitizeStorageDirectory('11111111-1111-4111-8111-111111111111'); // '11111111-1111-4111-8111-111111111111'
 * sanitizeStorageDirectory('../11111111-1111-4111-8111-111111111111'); // throws
 */
export function sanitizeStorageDirectory(directory: string): string {
  if (!EXACT_UUID_PATTERN.test(directory)) {
    throw new Error('Directory must be a UUID');
  }

  return directory;
}
